import React, { Component } from "react";
import Chart from "react-apexcharts";
import { Heading, Text } from "../../styled";
import { images } from "../../../config/index";
import { commonLocalization, number } from "../../../localization";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class EvaluationScoreChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: 0,
    };
  }

  getLabels = () => {
    return [
      `${number(0)}% - ${number(33)}%`,
      `${number(34)}% - ${number(66)}%`,
      `${number(67)}% - ${number(100)}%`,
    ];
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedLanguage !== this.props.selectedLanguage) {
      this.setState((prevState) => ({ key: prevState.key + 1 }));
    }
  }

  getSeries = () => {
    const { evaluatedScore, hoveredWardStats, wardWiseEvaluatedScore } =
      this.props;

    // If ward is hovered, get data for that specific ward
    if (hoveredWardStats) {
      const wardData = wardWiseEvaluatedScore.find(
        (w) => w.ward === hoveredWardStats.ward
      );
      if (wardData) {
        return [
          wardData.score_ranges["0-33"] || 0,
          wardData.score_ranges["34-66"] || 0,
          wardData.score_ranges["67-100"] || 0,
        ];
      }
      return [0, 0, 0];
    }

    if (!evaluatedScore) return [0, 0, 0];

    return [
      evaluatedScore["0-33"] || 0,
      evaluatedScore["34-66"] || 0,
      evaluatedScore["67-100"] || 0,
    ];
  };

  isChartDataEmpty = () => {
    const series = this.getSeries();
    return series.length > 0 && series.every((value) => value === 0);
  };

  getChartOptions = () => {
    const { selectedLanguage } = this.props;
    const { projects, project } = commonLocalization[selectedLanguage];

    return {
      chart: {
        type: "pie",
        toolbar: { show: false },
      },
      labels: this.getLabels(),
      dataLabels: {
        enabled: true,
        formatter: (val, opts) => {
          const value = this.getSeries()[opts.seriesIndex];
          return `${number(value)} ${value < 2 ? project : projects}`;
        },
      },
      tooltip: {
        y: {
          formatter: (val, opts) => {
            const label = this.getLabels()[opts.seriesIndex];
            return `${number(val)} ${val < 2 ? project : projects} (${number(
              label
            )})`;
          },
        },
      },
      legend: {
        position: "bottom",
      },
      colors: ["#9D830F", "#C5A313", "#ECC417"],
      stroke: {
        show: false,
      },
    };
  };

  render() {
    const {
      chartTitle = "Evaluation Score",
      chartHelpText = "Score breakdown",
      selectedLanguage,
      card = true,
      height = 400,
      width = 400,
    } = this.props;

    return (
      <div className='flex-layout gap-2 h-90'>
        <Heading.h2 uppercase className='chart-label flex items-center'>
          <Text.span className='help-text'>
            <Text.span className='help-text__icon'>
              <img
                className='help-icon'
                height={18}
                width={18}
                src={images.icons.help}
                alt='help'
              />
            </Text.span>
            <Text.span className='help-text__content tooltip'>
              <Text.span className='tooltip-arrow'>arrow</Text.span>
              {chartHelpText}
            </Text.span>
          </Text.span>
          <Text.span
            className={`uppercase opacity-70 ${
              selectedLanguage === "en" ? "text-xs" : "text-sm"
            }`}
          >
            {chartTitle}
          </Text.span>
        </Heading.h2>

        <div
          id='chart'
          className={`${
            card ? "card card--chart h-90" : ""
          } evaluation-chart flex flex-col justify-center items-center`}
        >
          {!this.isChartDataEmpty() ? (
            <Chart
              key={this.state.key}
              options={this.getChartOptions()}
              series={this.getSeries()}
              type='pie'
              height={height}
              width={width}
            />
          ) : (
            <div className='data-not-available mt-0'>
              <img src={images.dataNotAvailable} alt='data not available' />
              <Text.span>
                {commonLocalization[selectedLanguage]["dataNotAvailable"]}
              </Text.span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({
    selectedLanguage: state.localizationReducers.selectedLanguage,
  }))(EvaluationScoreChart)
);



// WEBPACK FOOTER //
// ./src/components/layouts/evaluationScoreChart/index.js